import { events, PlayerPlugin } from '@vpp/utils';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var AD_LOAD_TYPE_DAI = '2';
var VIDEO_AD_IS_SUPPORTED = '1';
var IS_FULL_EPISODE_TRUE = 'y';
var IS_FULL_EPISODE_FALSE = 'n';
var TYPE = 'content';
var DATA_SRC_CMS = 'cms';
var LIVE_STREAM_LENGTH = '86400';
var SEG_C_PLATFORM = 'Website';
var baseProperties = {
  adloadtype: AD_LOAD_TYPE_DAI,
  dataSrc: DATA_SRC_CMS,
  hasAds: VIDEO_AD_IS_SUPPORTED,
  type: TYPE,
  segC: SEG_C_PLATFORM
};
var liveProperties = {
  isfullepisode: IS_FULL_EPISODE_TRUE,
  length: LIVE_STREAM_LENGTH
};
var generateLiveMetadata = function generateLiveMetadata(_ref) {
  var channelName = _ref.channelName,
      mediaId = _ref.mediaId,
      subBrandId = _ref.subBrandId;
  return _objectSpread2({}, baseProperties, {}, liveProperties, {
    program: "".concat(channelName, " - Live"),
    title: "".concat(channelName, " - Live"),
    assetid: mediaId,
    subbrand: subBrandId,
    segB: channelName
  });
};
var generateVODMetadata = function generateVODMetadata(_ref2) {
  var duration = _ref2.duration,
      episodePlayerId = _ref2.episodePlayerId,
      _ref2$isShortForm = _ref2.isShortForm,
      isShortForm = _ref2$isShortForm === void 0 ? false : _ref2$isShortForm,
      seriesTitle = _ref2.seriesTitle,
      title = _ref2.title,
      subBrandId = _ref2.subBrandId;
  return _objectSpread2({}, baseProperties, {
    assetid: episodePlayerId,
    subbrand: subBrandId,
    isfullepisode: isShortForm ? IS_FULL_EPISODE_FALSE : IS_FULL_EPISODE_TRUE,
    length: duration,
    program: seriesTitle,
    title: title,
    segB: "VOD - ".concat(isShortForm ? 'Short' : 'Long', " Form")
  });
};
var generateAdMetadata = function generateAdMetadata(_ref3) {
  var id = _ref3.id,
      type = _ref3.type;
  return {
    assetid: id,
    type: type
  };
};

var Plugin = videojs.getPlugin('plugin');
var VIDEO_TYPE_VOD = 'vod';
var VIDEO_TYPE_LIVE = 'live';
var NIELSEN_EVENT_END = 'end';
var NIELSEN_EVENT_LOAD_METADATA = 'loadMetadata';
var NIELSEN_EVENT_SET_PLAYHEAD_POSITION = 'setPlayheadPosition';
var NIELSEN_EVENT_STOP = 'stop';
var INITIAL_TIME = -1;
var DELAY_NEXT_TICK = 1;
var MILLISECONDS_1S = 1000;
var NIELSEN_EVENT_INTERVAL_S = 1;
var NIELSEN_EVENT_INTERVAL_MS = NIELSEN_EVENT_INTERVAL_S * MILLISECONDS_1S;

var requestIdleCallbackFallback = function requestIdleCallbackFallback(callback) {
  return window.setTimeout(callback, DELAY_NEXT_TICK);
};

var cancelIdleCallbackFallback = window.clearTimeout;
var requestIdleCallback = window.requestIdleCallback || requestIdleCallbackFallback;
var cancelIdleCallback = window.cancelIdleCallback || cancelIdleCallbackFallback;

var getUnixTime = function getUnixTime() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
  return time / MILLISECONDS_1S;
};

var getDelta = function getDelta(a, b) {
  return Math.abs(a - b);
};

var NielsenPlugin =
/*#__PURE__*/
function (_Plugin) {
  _inherits(NielsenPlugin, _Plugin);

  function NielsenPlugin(_player, options) {
    var _this;

    _classCallCheck(this, NielsenPlugin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NielsenPlugin).call(this, _player, options));

    _defineProperty(_assertThisInitialized(_this), "generateContentMetadata", function (player, subBrandId) {
      var video = player.mediainfo;

      if (_this.videoType === VIDEO_TYPE_LIVE) {
        return generateLiveMetadata({
          channelName: video.name,
          mediaId: video.id,
          subBrandId: subBrandId
        });
      }

      var duration = video.duration,
          episodePlayerId = video.referenceId,
          title = video.name;
      var seriesTitle = video.customFields && video.customFields.content_showname || _this.defaultProgramName;
      return generateVODMetadata({
        duration: Math.floor(duration),
        episodePlayerId: episodePlayerId,
        seriesTitle: seriesTitle,
        title: title,
        isShortForm: _this.handleShortForm(video),
        subBrandId: subBrandId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getVideoType", function (player) {
      var video = player.mediainfo;
      if (!video.customFields || !video.customFields.video_type) return VIDEO_TYPE_VOD;
      return video.customFields.video_type;
    });

    _defineProperty(_assertThisInitialized(_this), "init", function () {
      _this.one(_this.player, events.player.play, _this.handleFirstPlay);

      _this.one(_this.player, events.player.loadedmetadata, _this.handleLoadedMetadata); // this.on(this.player, events.player.contentupdate, this.handleContentUpdate)


      _this.on(_this.player, events.player.contentWillUpdate, _this.handleContentUpdate);

      _this.on(_this.player, events.ads.ADS_AD_STARTED, _this.handleAdsAdStarted);

      _this.on(_this.player, events.ads.ADS_AD_ENDED, _this.handleAdsAdEnded);

      _this.on(_this.player, events.media.ENDED, _this.handleEnded);
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnded", function () {
      _this.triggerEndEvent(_this.player.duration());

      _this.one(_this.player, events.media.PLAY, function () {
        _this.triggerLoadMetadata();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePause", function () {
      // As "ended" has its own associated Nielsen event, we ignore any pauses
      // that occur after the player has ended.
      if (_this.player.scrubbing() || _this.player.ended()) {
        return;
      }

      _this.triggerStopEvent(_this.previousTime);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAdsPause", function () {
      _this.triggerStopEvent(_this.adPreviousTime);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAdsAdEnded", function () {
      // The adtimeupdate event is fired after `contentplayback`, as the
      // currentTime of the ad is reset to 0:00. If the previous time is zero,
      // the setPlayheadPosition event will not fire, as the currentTime never
      // reaches 1s.
      _this.adPreviousTime = 0;

      if (_this.player.usingPlugin('ima3')) {
        _this.off(_this.player.ima3.adPlayer, events.media.TIMEUPDATE, _this.handleIma3TimeUpdate);

        _this.off(_this.player, events.ads.ADS_PAUSE, _this.handleAdsPause);
      } else {
        _this.off(_this.player, events.ads.ADTIMEUPDATE, _this.handleSSAITimeUpdate);
      } // When multiple ads play during an ima3 ad-pod, the player resets to 0:00
      // before changing to the next ad. This prevents incorrectly sending the
      // setPlayheadPosition event with a payload of 0 at the end of the ad.


      cancelIdleCallback(_this.idleCallbackId);
      var duration = Math.floor(_this.player.ads.ad.duration);

      _this.triggerStopEvent(duration);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAdsAdStarted", function () {
      _this.triggerLoadAdMetadata();

      _this.adPreviousTime = INITIAL_TIME; // "adtimeupdate" is not fired by ima3, so ima3 is treated differently.

      if (_this.player.usingPlugin('ima3')) {
        _this.on(_this.player.ima3.adPlayer, events.media.TIMEUPDATE, _this.handleIma3TimeUpdate);

        _this.on(_this.player, events.ads.ADS_PAUSE, _this.handleAdsPause);
      } else {
        _this.on(_this.player, events.ads.ADTIMEUPDATE, _this.handleSSAITimeUpdate);
      } // "contentplayback" event is triggered when swapping from ad-pod to main
      // content. In the case of ads not playing due to an ad-timeout or similar,
      // "contentplayback" will still occur, so we only want to load the content
      // metadata if an ad has actually started playing. In the case of multiple
      // ads playing in the one ad pod, we don't want to handle "contentplayback"
      // multiple times.


      _this.off(_this.player, events.ads.CONTENTPLAYBACK, _this.handleContentPlayback);

      _this.one(_this.player, events.ads.CONTENTPLAYBACK, _this.handleContentPlayback);
    });

    _defineProperty(_assertThisInitialized(_this), "handleContentUpdate", function () {
      var previousTime = _this.previousTime;
      console.log('triggering.content.update', {
        previousTime: previousTime,
        brandId: _this.subBrandId
      });

      _this.triggerStopEvent(previousTime);

      _this.videoType = _this.getVideoType(_this.player);
      _this.contentMetadata = _this.generateContentMetadata(_this.player, _this.subBrandId);

      _this.triggerLoadMetadata();
    });

    _defineProperty(_assertThisInitialized(_this), "handleContentPlayback", function () {
      _this.triggerLoadMetadata(); // We want to trigger the 'stop' event when an ad pod commences, but only
      // for midrolls. We can ensure this by listening for the event after the
      // contentplayback event occurs.


      _this.one(_this.player, events.ads.ADS_POD_STARTED, function () {
        _this.triggerStopEvent(_this.previousTime);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFirstPlay", function () {
      _this.triggerLoadMetadata();
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoadedMetadata", function () {
      // The pause event is sometimes fired immediately after calling play(),
      // typically when using an adblocker and playing live content. Waiting
      // until after "firstplay" is called before listening to pauses sidesteps
      // this issue.
      _this.on(_this.player, events.media.PAUSE, _this.handlePause); // The 'ads-pause' event fires when SSAI ad playback is initiated, but
      // before the ad begins playing. This ensures that the pause event is only
      // listened to after the 'adplay' occurs.


      _this.one(_this.player, events.ads.ADPLAY, function () {
        _this.on(_this.player, events.ads.ADS_PAUSE, _this.handleAdsPause);
      });

      if (_this.videoType === VIDEO_TYPE_VOD) {
        _this.on(_this.player, events.media.TIMEUPDATE, _this.handleVODTimeUpdate);
      } else if (_this.videoType === VIDEO_TYPE_LIVE) {
        _this.on(_this.player, events.media.TIMEUPDATE, _this.handleLiveTimeUpdate);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleTimeUpdate", function (now, previous) {
      var nowFloored = Math.floor(now);
      var delta = getDelta(nowFloored, previous);

      if (delta >= NIELSEN_EVENT_INTERVAL_S) {
        _this.triggerSetPlayheadPosition(nowFloored);

        return nowFloored;
      }

      return previous;
    });

    _defineProperty(_assertThisInitialized(_this), "handleAdTimeUpdate", function (now) {
      _this.adPreviousTime = _this.handleTimeUpdate(now, _this.adPreviousTime);
    });

    _defineProperty(_assertThisInitialized(_this), "handleContentTimeUpdate", function (now) {
      _this.previousTime = _this.handleTimeUpdate(now, _this.previousTime);
    });

    _defineProperty(_assertThisInitialized(_this), "handleLiveTimeUpdate", function () {
      var now = getUnixTime();

      _this.handleContentTimeUpdate(now);
    });

    _defineProperty(_assertThisInitialized(_this), "handleVODTimeUpdate", function () {
      if (_this.player.scrubbing()) {
        return;
      }

      var now = _this.player.currentTime();

      _this.handleContentTimeUpdate(now);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSSAITimeUpdate", function () {
      var now = _this.player.currentTime();

      _this.handleAdTimeUpdate(now);
    });

    _defineProperty(_assertThisInitialized(_this), "handleIma3TimeUpdate", function () {
      var now = _this.player.ima3.adPlayer.currentTime();

      _this.handleAdTimeUpdate(now);
    });

    _defineProperty(_assertThisInitialized(_this), "triggerLoadAdMetadata", function () {
      var _this$player$ads = _this.player.ads,
          type = _this$player$ads.adType,
          id = _this$player$ads.ad.id;
      var metadata = generateAdMetadata({
        type: type,
        id: id
      });

      _this.triggerLoadMetadata(metadata);
    });

    _defineProperty(_assertThisInitialized(_this), "triggerNielsenEvent", function (eventName, payload) {
      _this.idleCallbackId = requestIdleCallback(function () {
        return window.NOLBUNDLE[_this.instanceName].ggPM(eventName, payload);
      }, {
        timeout: NIELSEN_EVENT_INTERVAL_MS
      });
    });

    _defineProperty(_assertThisInitialized(_this), "triggerStopEvent", function (playheadPosition) {
      _this.triggerNielsenEvent(NIELSEN_EVENT_STOP, playheadPosition);
    });

    _defineProperty(_assertThisInitialized(_this), "triggerEndEvent", function (playheadPosition) {
      _this.triggerNielsenEvent(NIELSEN_EVENT_END, Math.floor(playheadPosition));
    });

    _defineProperty(_assertThisInitialized(_this), "triggerLoadMetadata", function () {
      var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.contentMetadata;

      _this.triggerNielsenEvent(NIELSEN_EVENT_LOAD_METADATA, metadata);
    });

    _defineProperty(_assertThisInitialized(_this), "triggerSetPlayheadPosition", function (playheadPosition) {
      _this.triggerNielsenEvent(NIELSEN_EVENT_SET_PLAYHEAD_POSITION, playheadPosition);
    });

    _this.instanceName = options.instanceName;
    _this.defaultProgramName = options.programName;
    _this.videoType = _this.getVideoType(_player);
    _this.subBrandId = options.subBrandId;
    _this.contentMetadata = _this.generateContentMetadata(_player, options.subBrandId);
    _this.previousTime = INITIAL_TIME;
    _this.adPreviousTime = INITIAL_TIME;

    if (window.NOLBUNDLE && window.NOLBUNDLE[_this.instanceName]) {
      _this.init();
    } else {
      videojs.log.warn('Nielsen SDK or instance not found, no events will be tracked.');
    }

    return _this;
  }

  _createClass(NielsenPlugin, [{
    key: "handleShortForm",
    value: function handleShortForm(video) {
      if (!video.customFields || typeof video.customFields.content_type !== 'string') return true;
      var contentType = video.customFields.content_type.toLowerCase();
      return contentType !== 'episode' && contentType !== 'movie';
    }
  }]);

  return NielsenPlugin;
}(Plugin);

var version = "0.8.1";

var NielsenPlugin$1 =
/*#__PURE__*/
function (_PlayerPlugin) {
  _inherits(NielsenPlugin$1, _PlayerPlugin);

  function NielsenPlugin$1(config) {
    var _this;

    _classCallCheck(this, NielsenPlugin$1);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NielsenPlugin$1).call(this, config));

    _defineProperty(_assertThisInitialized(_this), "pluginName", 'nielsen');

    if (!_this._config.NIELSEN_API_KEY || _this._config.DISABLE_NIELSEN) return _possibleConstructorReturn(_this);

    if (!window.NOLBUNDLE && !_this._config.NIELSEN_DISABLE_SDK_LOAD) {
      _this.loadNielsenSDK();
    }

    videojs.registerPlugin('nielsen', NielsenPlugin);
    return _this;
  }

  _createClass(NielsenPlugin$1, [{
    key: "afterVideo",
    value: function afterVideo(player, options) {
      return this.nielsen(player, options);
    }
  }, {
    key: "nielsen",
    value: function nielsen(player, options) {
      if (typeof player.nielsen !== 'function' || this._config.DISABLE_NIELSEN || !this._config.NIELSEN_API_KEY || options.disableNielsen || !player.mediainfo) return;
      var instanceName = options.nielsenInstanceName || this._config.NIELSEN_INSTANCE_NAME || this._config.NIELSEN_API_KEY;
      var config = {
        subBrandId: this._config.NIELSEN_SUB_BRAND_ID,
        programName: this._config.NIELSEN_PROGRAM_NAME,
        instanceName: instanceName
      };
      var nlsnConfig = {};

      if (this._config.NIELSEN_SDK_DEBUG) {
        nlsnConfig.nol_sdkDebug = this._config.NIELSEN_SDK_DEBUG;
      } else if (options.nielsenSdkDebug) {
        nlsnConfig.nol_sdkDebug = options.nielsenSdkDebug;
      }

      window.NOLBUNDLE.nlsQ(this._config.NIELSEN_API_KEY, instanceName, nlsnConfig);
      player.nielsen(config);
    }
  }, {
    key: "loadNielsenSDK",
    value: function loadNielsenSDK() {
      var nlsQ = function nlsQ(apiKey, name, config) {
        var script = document.createElement('script');
        script.async = 1;
        script.src = "//cdn-gl.imrworldwide.com/conf/".concat(apiKey, ".js#name=").concat(name, "&ns=NOLBUNDLE");
        var mount = document.getElementsByTagName('script')[0];
        mount.parentNode.insertBefore(script, mount);
        window.NOLBUNDLE[name] = window.NOLBUNDLE[name] || {
          g: config || {},
          ggPM: function ggPM(e, c, r, s, i) {
            (window.NOLBUNDLE[name].q = window.NOLBUNDLE[name].q || []).push([e, c, r, s, i]);
          }
        };
        return window.NOLBUNDLE[name];
      };

      window.NOLBUNDLE = window.NOLBUNDLE || {
        nlsQ: nlsQ
      };
    }
  }]);

  return NielsenPlugin$1;
}(PlayerPlugin);

_defineProperty(NielsenPlugin$1, "VERSION", version);

export default NielsenPlugin$1;
